export const DeviceServicesInfoTableHeader = {
  columns: {
    devAuditId: {
      title: 'Аудит ID',
      filter: true
    },
    eui: {
      title: 'Серийный номер',
      filter: true
    },
    creationTime: {
      title: 'Принято на учет',
      filter: true
    },
    deletionTime: {
      title: 'Снято с учета',
      filter: true
    },
    active: {
      title: 'Статус устройства',
      filter: true
    }
  },
  actions: {
    add:    false,
    edit:   false,
    delete: false
  },
  pager: {
    perPage: 10
  }
};



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/models/DeviceServicesInfoTableHeader.ts